import { axios } from "@/axios"
import { EventTemplate } from "@/models"

/**
 * Creates a new custom template. This is used for advanced templates.
 *
 * @param {EventTemplate} template - The template details including name, description, images, and social media links.
 * @param {number} [hostAccountId] - Optional ID of the host account to associate the template template with, mainly used by admins.
 * @returns {Promise<EventTemplate>} The newly created event template.
 */
export async function createCustomTemplate(template: EventTemplate, hostAccountId?: number) {
  const form = new FormData()

  if (template.name)
    form.append("Name", template.name)
  if (template.description)
    form.append("Description", template.description)
  if (template.headerImage)
    form.append("HeaderImage", template.headerImage)
  if (template.footerImage)
    form.append("FooterImage", template.footerImage)

  const socialMediaLinks = template.customFooterLinks?.socialLinks

  if (socialMediaLinks?.facebook)
    form.append("TemplateSettings[CustomFooterLinks][SocialLinks][Facebook]", socialMediaLinks?.facebook)
  if (socialMediaLinks?.instagram)
    form.append("TemplateSettings[CustomFooterLinks][SocialLinks][Instagram]", socialMediaLinks?.instagram)
  if (socialMediaLinks?.youtube)
    form.append("TemplateSettings[CustomFooterLinks][SocialLinks][Youtube]", socialMediaLinks?.youtube)
  if (socialMediaLinks?.tiktok)
    form.append("TemplateSettings[CustomFooterLinks][SocialLinks][Tiktok]", socialMediaLinks?.tiktok)
  if (socialMediaLinks?.pinterest)
    form.append("TemplateSettings[CustomFooterLinks][SocialLinks][Pinterest]", socialMediaLinks?.pinterest)
  if (socialMediaLinks?.linkedIn)
    form.append("TemplateSettings[CustomFooterLinks][SocialLinks][LinkedIn]", socialMediaLinks?.linkedIn)
  if (socialMediaLinks?.x)
    form.append("TemplateSettings[CustomFooterLinks][SocialLinks][X]", socialMediaLinks?.x)

  const footerLinks = template.customFooterLinks?.footerLinks || []

  footerLinks.forEach((link, index) => {
    if (link.key)
      form.append(`TemplateSettings[CustomFooterLinks][FooterLinks][${index}][Key]`, link.key)
    if (link.value)
      form.append(`TemplateSettings[CustomFooterLinks][FooterLinks][${index}][Value]`, link.value)
  })

  const endpoint = hostAccountId
    ? `api/template?hostAccountId=${hostAccountId}`
    : `api/template`

  const response = await axios.post(endpoint, form, {
    headers: { "Content-Type": "multipart/form-data" },
  })

  return EventTemplate.fromResponse(response.data.Data)
}
